import { LanguageCode } from '@cta-portal/webapp-common/lib/api/schema';
import { Language } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
export function compareArrays(arr1, arr2) {
    if (arr1.length !== arr2.length)
        return false;
    for (var _i = 0, arr1_1 = arr1; _i < arr1_1.length; _i++) {
        var elem = arr1_1[_i];
        if (!arr2.includes(elem))
            return false;
    }
    return true;
}
export function getKeyFromEnum(value) {
    return value.toLowerCase().replaceAll('_', '-');
}
export function languageCodeToLanguageKey(value) {
    return value.split('_')[0].toLowerCase();
}
export function languageKeyToLanguageCode(value) {
    switch (value) {
        case Language.EN: {
            return LanguageCode.EN_EN;
        }
        case Language.FR: {
            return LanguageCode.FR_FR;
        }
        case Language.JA: {
            return LanguageCode.JA_JP;
        }
        default: {
            return LanguageCode.EN_EN;
        }
    }
}
